const giftCardDate = (state = new Date(), action) => {
    switch(action.type) {
        case 'giftCardDate':
            return action.payload;
        default:
            return state;
    }
}

export default giftCardDate;